import React, {useEffect} from 'react'
import { Container, Text, Row, Spacer, Table, Badge, Tooltip, Loading, Button, Modal, Col } from '@nextui-org/react'
import { AiFillEye } from 'react-icons/ai'
import { IconButton } from './IconButton';
import moment from 'moment/moment';
import { useSms } from '../Hooks/useSms';
import { HiOutlineRefresh, HiClipboardCopy } from 'react-icons/hi'
import { toast } from 'react-toastify';
import 'moment/locale/fr'
moment.locale('fr')

const HistoricBlock = () => {
    const [visible, setVisible] = React.useState(false);
    const [index, setIndex] = React.useState(0);
    const { sms, loadingSms, error, refreshSms } = useSms();

    const openHandler = () => {
        setVisible(true);
    };

    const closeHandler = () => {
        setVisible(false);
    };

    const renderBadge = (status) => {
        switch (status) {
            case "Success":
                return <Badge color="success">Envoyé</Badge>
            case "Waiting":
                return <Badge color="warning">En attente</Badge>
            case "Error":
                return <Badge color="error">Erreur</Badge>
            default:
                return <Badge color="default">Inconnu</Badge>
        }
    }

    const copyToClipBoard = (text) => {
        navigator.clipboard.writeText(text);
        toast.info("Message copié dans le presse papier.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
        });
    }

    
  return (
    <Container responsive xs css={{ shadow: "$lg", borderRadius: '$2xl', pb: '$5' }}>
        <Row justify='space-between'>
            <Text h3 css={{alignSelf: "center", mt: '$3'}}>Historique des messages</Text>
            <Spacer/>
            <Button css={{mt: '$4', mr:'$5'}} auto shadow onClick={() => refreshSms()} color="primary">
                <HiOutlineRefresh size={20} />
            </Button>
        </Row>
        {
            loadingSms ? 
                <Loading color="primary" size="large" type='spinner' />
            : sms.length === 0 ?
                <Container css={{shadow: "$lg", borderRadius: '$2xl', mt: '$3', width: "200px", padding: '$5' }}>
                    <Text h4 color='primary' b css={{alignSelf: "center", mt: '$3'}}>Aucun message envoyé</Text>
                </Container>
            :
            <Table
                color="primary"
                striped
                aria-label="Example pagination table"
            >
            <Table.Header>
                <Table.Column>DATE</Table.Column>
                <Table.Column>DESTINATAIRE</Table.Column>
                <Table.Column>STATUS</Table.Column>
                <Table.Column>ACTION</Table.Column>
            </Table.Header>
            <Table.Body>
                {
                    sms.map((item, index) => (
                        <Table.Row key={index}>
                            <Table.Cell>{moment(item.date.toDate()).format("DD/MM/YYYY - hh:mm:ss")}</Table.Cell>
                            <Table.Cell>{item.number.map((i) => i)}</Table.Cell>
                            <Table.Cell>
                                {renderBadge(item.status)}
                            </Table.Cell>
                            <Table.Cell>
                                <Row align='center'>
                                <Tooltip content="Voir détail" color={"primary"}>
                                    <IconButton onClick={() => {setIndex(index); openHandler()}}>
                                        <AiFillEye size={20}  fill="primary"/>
                                    </IconButton>
                                </Tooltip>
                                </Row>
                            </Table.Cell>
                        </Table.Row>
                    ))
                }
            </Table.Body>
            <Table.Pagination
                shadow
                noMargin
                align="center"
                rowsPerPage={7}
            />
            </Table>
        }
        {
            loadingSms ? 
                <Loading color="primary" size="large" type='spinner' /> 
            : sms.length !== 0 ?
            <Modal
                closeButton
                open={visible}
                onClose={closeHandler}
            >
                <Modal.Header>
                <Text b size={18}>
                    Detail du message
                </Text>
                </Modal.Header>
                <Modal.Body>
                    <Text b size={18}>
                        Date
                    </Text>
                    <Text size={16}>
                        {moment(sms[index].date.toDate()).format("DD/MM/YYYY, hh:mm:ss")}
                    </Text>
                    <Row align='center' justify='center'>
                        <Col>
                        <Text b size={18}>
                            Message
                        </Text>
                        <Text size={16}>
                            {sms[index].text}
                        </Text>
                        </Col>
                        <div style={{cursor: 'pointer'}}>
                            <HiClipboardCopy onClick={() => copyToClipBoard(sms[index].text)} size={30} color={"#1775EE"}/> 
                        </div>
                    </Row>
                    <Spacer y={1} />
                    <Text b size={18}>
                        Destinataire
                    </Text>
                    <Text size={16}>
                        {sms[index].number.map((i) => i)}
                    </Text>
                    <Spacer y={1} />
                    <Text b size={18}>
                        Status
                    </Text>
                    <Text size={16}>
                        {renderBadge(sms[index].status)}
                    </Text>
                    <Spacer y={1} />
                </Modal.Body>
                <Modal.Footer>
                <Button auto flat color="error" onPress={closeHandler}>
                    Fermer
                </Button>
                </Modal.Footer>
            </Modal>:
            <></>
        }
        
    </Container>
  )
}

export default HistoricBlock;